import ChevronUp24 from './ChevronUp24';
import ChevronUp16 from './ChevronUp16';
type Props = {
  size?: 16 | 24;
  color?: string;
  [key: string]: any;
};

const assets = {
  24: ChevronUp24,
  16: ChevronUp16,
};

export default ({ size = 16, color, ...args }: Props) => {
  const Asset = assets[size];
  return (
    <span className="oksoon-icon oksoon-icon--ChevronUp" {...args}>
      <Asset color={color} />
    </span>
  );
};
